import Vue from 'vue'

export default {

  setToken (token) {
    localStorage.setItem('token', token)

    // store in cookie with 30 days expires
    let validDays = 30
    let d = new Date()
    d.setTime(d.getTime() + (validDays * 24 * 60 * 60 * 1000))
    document.cookie = `token=${token}; expires=${d.toUTCString()}; SameSite=Strict; Secure`
  },

  getCookieToken () {
    let token = document.cookie.split('; ').find(row => row.startsWith('token'))
    return token ? token.replace(/^token=/, '') : token
  },

  getToken () {
    let token = this.getCookieToken()
    if (!token) token = localStorage.getItem('token')

    // update token everytime we get it, to keep it fresh in cookie
    if (token) this.setToken(token)

    return token
  },

  authorize () {
    let token = this.getToken()
    if (location.href.startsWith('http://localhost') && !token) {
      token = 'test'
      this.setToken(token)
    }
    if (token) {
      Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      return true
    }
    return false
  }

}



// WEBPACK FOOTER //
// ./src/utils/authorization.js